import { put } from "redux-saga/effects";
import { serverRequest } from "../../actions";

export function* reconnect3(action) {
  var payload = {
    action: "portal/reconnect3",
    token: action.token,
  };
  yield put(serverRequest(payload));
}

export default reconnect3;
